import { render, staticRenderFns } from "./BaseActivity.vue?vue&type=template&id=be43e816&scoped=true"
import script from "./BaseActivity.vue?vue&type=script&lang=js"
export * from "./BaseActivity.vue?vue&type=script&lang=js"
import style0 from "./BaseActivity.vue?vue&type=style&index=0&id=be43e816&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be43e816",
  null
  
)

export default component.exports